const ITEMS = [
  "Movimento Gera Mudança",
  "FW Team Fitness",
  "Constância & Orientação",
  "Emagrecimento",
  "Hipertrofia",
  "Qualidade de Vida",
];

function MarqueeContent({ hidden = false }) {
  return (
    <div className="flex items-center" aria-hidden={hidden || undefined}>
      {ITEMS.map((text) => (
        <span
          key={text}
          className="flex items-center whitespace-nowrap font-display text-sm font-bold uppercase tracking-[0.32em] text-brand-blue/35"
        >
          <span className="px-8">{text}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-brand-blue/60" />
        </span>
      ))}
    </div>
  );
}

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-white/10 bg-[#0a0e16] py-5"
    >
      <div className="animate-marquee flex w-max items-center">
        <MarqueeContent />
        <MarqueeContent hidden />
      </div>
    </div>
  );
}
